import { apiFetch } from "./api";


// GET - Obtener todos los casos (jerarquía padre-hijo)
export const getCases = async () => {
  const res = await apiFetch('/cases');

  if (!res.ok) {
    throw new Error("Error al obtener casos");
  }

  return await res.json();
};

// GET - Obtener caso específico con hijos
export const getCase = async (id) => {
  const res = await apiFetch(`/cases/${id}`);

  if (!res.ok) {
    throw new Error("Error al obtener el caso");
  }

  return await res.json();
};

// POST - Crear caso padre
export const createParentCase = async (formData) => {
  const res = await apiFetch('/cases', {
    method: "POST",
    body: formData,
  });

  const data = await res.json();

  if (!res.ok) {
    throw new Error(data.message || "Error al crear el caso padre");
  }

  return data;
};

// POST - Crear caso hijo
export const createChildCase = async (parentId, formData) => {
  const res = await apiFetch(`/cases/${parentId}/children`, {
    method: "POST",
    body: formData,
  });

  const data = await res.json();

  if (!res.ok) {
    throw new Error(data.message || "Error al crear el caso hijo");
  }

  return data;
};

// PUT - Actualizar caso
export const updateCase = async (id, formData) => {
  const res = await apiFetch(`/cases/${id}`, {
    method: "PUT", // Laravel usa POST con _method=PUT para FormData
    body: formData,
  });

  const data = await res.json();

  if (!res.ok) {
    throw new Error(data.message || "Error al actualizar el caso");
  }

  return data;
};

// DELETE
export const deleteCase = async (id) => {
  const res = await apiFetch(`/cases/${id}`, {
    method: "DELETE",
  });

  if (!res.ok) {
    const data = await res.json();
    throw new Error(data.message || "Error al eliminar");
  }

  return { success: true };
};
//RESET Cases
export const resetCases = async () => {
  const res = await apiFetch('/cases-reset', {
    method: "POST",
  });

  if (!res.ok) {
    const data = await res.json();
    throw new Error(data.message || "Error al resetear casos");
  }

  return { success: true };
}

